import { OTHER_IMAGERY } from '../constants/mapLayerIds';

/**
 * Use sub layer identifier to get the corresponding layer
 * @param {object} layers - All layers.
 * @param {object} activeSubLayerId - Identifier of the target layer.
 * @return {object} other imagery sub layer
 */
const getActiveOtherImagerySubLayer = (layers, activeSubLayerId) => {
  if (!activeSubLayerId) {
    return {};
  }

  const { vendor, layer, index } = activeSubLayerId;
  return layers[vendor][layer][index];
};

export default {
  [OTHER_IMAGERY]: getActiveOtherImagerySubLayer,
};
